import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import LandingPageNew from "./components/LandingPageNew";
import LandingPage from "./components/LandingPage";

const LandingApp = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </Router>
  );
};

export default LandingApp;
